// NPC diyalog metinleri. Tip bazlı; {name} yerine NPC adı gelir.

const TR = {
  common: {
    task: 'Senin için yapabileceğim bir iş var mı?',
    talk: 'Biraz sohbet edelim.',
    bye: 'Hoşça kal.',
    back: 'Başka bir şey soracaktım.',
    backToTalk: 'Konuşmaya dön',
    taskIntro: 'Aslında bir işim var. Dinle bakalım…',
    continue: 'devam',
    skip: 'Atlamak için tıkla',
    afterBack: ['Başka?', 'Söyle bakalım.', 'Dinliyorum.'],
  },
  demirci: {
    main: 'Artı basmak istiyorum.',
    greet: ['Örsün başında laf az olur. Ne istiyorsun?', 'Ateş tam kıvamında. Getir silahını, bir bakalım.', 'Demir sıcakken dövülür, yolcu. Söyle.'],
    talk: ['Her vuruş demiri güçlendirir ama demir de yorulur.', 'Yüksek artılarda iş şansa kalır. Tutmazsa eşya kırılabilir. Baştan söyleyeyim, sonra bana kızma.'],
    service: ['Koy şunu örse, bakalım.', 'Hangisini basıyoruz?', 'Ateş hazır.'],
  },
  market: {
    main: 'Bakalım neler satıyorsun?',
    greet: ['Hoş geldin yolcu! Ne ararsan bende.', 'Ooo, tanıdık bir yüz! Kesen dolu mu bugün?', 'Yeni mallar geldi, bir bak istersen.'],
    talk: ['Kervanlar köye uğramadan önce mal da haber de bana gelir.', 'İksirsiz yola çıkan geri dönmez. Benden söylemesi.'],
    service: ['Gözün neyi tuttu?', 'Bereketli olsun.', 'Pazarlık yok ama mal sağlam.'],
  },
  silahci: {
    main: 'Silahlarına bakayım.',
    greet: ['Elin boş mu geldin? Burada boş kalmaz.', 'Keskin mi arıyorsun, ağır mı?'],
    talk: ['İyi silah sahibini seçer derler. Ben derim ki iyi silah iyi bilenir.', 'Canavarların derisi köyden uzaklaştıkça kalınlaşır. Silahını ona göre seç.'],
    service: ['Tart bakalım, elinde nasıl duruyor?', 'Bunlar en iyileri.'],
  },
  zirhci: {
    main: 'Zırhlarını göster.',
    greet: ['Kalkansız yürüyen uzun yürümez.', 'Gel, sana uygun bir zırh bulalım.'],
    talk: ['Zırhın ağırı seni yavaşlatır, hafifi seni öldürür. Arası bulunur.', 'Halkaları tek tek ben ördüm, her biri bir gece sürdü.'],
    service: ['Ölçüne uygun olanlar şunlar.', 'Dene bakalım.'],
  },
  bahcivan: {
    main: 'Bakalım hangi tohumların var?',
    greet: ['Toprak sabır ister. Hoş geldin.', 'Yağmur iyi geldi bu sene. Ne lazım?'],
    talk: ['Tohumu doğru zamanda ek, suyunu eksik etme. Gerisini toprak halleder.', 'Her köyün toprağı başka. Ne yetiştireceğini ona göre seç.'],
    service: ['Bunlar bu mevsimin tohumları.', 'Bol bereket.'],
  },
  balikci: {
    main: 'Olta takımlarına bakalım.',
    greet: ['Sabah erken çıkan balığı tutar. Hoş geldin.', 'Su sakin bugün. Ne lazım?'],
    talk: ['Balık sabırsızı sevmez. Oltayı at, bekle.', 'Derin sularda iri balık olur ama misinan sağlam olmalı.'],
    service: ['Takımlar burada.', 'Rast gele!'],
  },
  madenci: {
    main: 'Kazma ve aletlerine bakayım.',
    greet: ['Toz toprak içindeyim, kusura bakma. Ne lazım?', 'Damar derinde, kazma sağlam olmalı.'],
    talk: ['Yeraltında ışığın sönerse dur, nefesini dinle.', 'Her taş bir değil. Parlayanı bırakma.'],
    service: ['Aletlerim sağlamdır.', 'Bol kazançlar.'],
  },
};

const EN = {
  common: {
    task: 'Is there any work I can do for you?',
    talk: "Let's talk a bit.",
    bye: 'Farewell.',
    back: 'I wanted to ask something else.',
    backToTalk: 'Back to talk',
    taskIntro: 'Actually, I do have something. Listen…',
    continue: 'next',
    skip: 'Click to skip',
    afterBack: ['Anything else?', 'Go on.', "I'm listening."],
  },
  demirci: {
    main: 'I want to enhance an item.',
    greet: ['Few words at the anvil. What do you need?', 'The fire is just right. Bring your weapon.'],
    talk: ['Every strike strengthens the iron, but iron tires too.', 'At high levels it comes down to luck. If it fails, the item may break.'],
    service: ['Put it on the anvil.', 'Which one are we enhancing?'],
  },
  market: {
    main: "Let's see what you're selling.",
    greet: ['Welcome, traveler! Whatever you need, I have it.', 'A familiar face! Is your purse full today?'],
    talk: ['Caravans bring goods and news to me first.', 'Never leave without potions.'],
    service: ['What caught your eye?', 'May it serve you well.'],
  },
  silahci: { main: 'Show me your weapons.', greet: ['Empty-handed? Not for long.'], talk: ['A good weapon is a well-sharpened one.'], service: ['Feel the weight.'] },
  zirhci: { main: 'Show me your armor.', greet: ['Walk without a shield and you will not walk long.'], talk: ['Heavy armor slows you, light armor kills you.'], service: ['These should fit you.'] },
  bahcivan: { main: 'What seeds do you have?', greet: ['Soil needs patience. Welcome.'], talk: ['Plant on time and never skip the water.'], service: ["This season's seeds."] },
  balikci: { main: "Let's see your fishing gear.", greet: ['Early risers catch the fish.'], talk: ['Fish do not like the impatient.'], service: ['Tight lines!'] },
  madenci: { main: 'Show me your tools.', greet: ['Excuse the dust. What do you need?'], talk: ['If your light goes out underground, stop and listen.'], service: ['My tools are sturdy.'] },
};

export function getNpcLines(type, lang) {
  const src = lang && lang.startsWith('en') ? EN : TR;
  const t = src[type] || src.market;
  return { ...t, common: src.common };
}

export const pick = (arr) => (Array.isArray(arr) && arr.length ? arr[Math.floor(Math.random() * arr.length)] : '');
